import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Auth, signOut, User as FirebaseUser, signInWithEmailAndPassword } from '@angular/fire/auth'
import { Router } from '@angular/router'

import { finalize, from, Observable, switchMap, tap } from 'rxjs'

import { User } from '@yoshu-lib/models/user.model'

import { TranslateService } from '@ngx-translate/core'

import { environment } from '@coty/env/environment'

import { AuthStore } from './auth.store'

@Injectable({ providedIn: 'root' })
export class AuthService {
  private auth = inject(Auth)
  private authStore = inject(AuthStore)
  private router = inject(Router)
  private http = inject(HttpClient)
  private translate = inject(TranslateService)

  signInWithGoogle(email: string, password: string) {
    this.auth.tenantId = environment.tenantId
    this.authStore.setIsLoggingIn(true)

    return from(
      signInWithEmailAndPassword(this.auth, email, password).then((res) => res.user)
    ).pipe(finalize(() => this.authStore.setIsLoggingIn(false)))
  }

  loginToYoshuApi(firebaseUser: FirebaseUser) {
    return from(firebaseUser.getIdToken()).pipe(
      switchMap((idToken) => {
        return this.http
          .post<User>(`${environment.apiUrl}/login`, { firebase_id_token: idToken })
          .pipe(
            tap((user) => {
              this.authStore.setUser(user)

              const userLang = user.yoshu_language?.split('-')[0]
              const currentLang = this.translate.currentLang

              if (userLang && userLang !== currentLang) {
                this.translate.use(userLang)
              }
            })
          )
      })
    )
  }

  logout(): Observable<void> {
    return from(signOut(this.auth)).pipe(
      tap(() => {
        this.authStore.setUser(null)
        this.router.navigate(['/login'])
      })
    )
  }
}
